<div class="form-like">
  <div class="form-group">
    <label class="form-label">Organization Name</label>
    <input *ngIf="editable" type="input" class="form-control" [ngModel]="displayName">
    <label *ngIf="!editable" [innerHTML]="displayName"></label>
  </div>
  <div class="form-group">
    <label class="form-label">Login Name</label>
    <input *ngIf="editable" type="input" class="form-control" [(ngModel)]="identity">
    <label *ngIf="!editable" [innerHTML]="identity"></label>
  </div>
  <div class="form-group">
    <label class="form-label">Password</label>
    <div class="form-like">
      <button (click)="NeedReset()" [class.hidden]="needsReset" type="button"
        class="btn btn-danger btn-md">Reset</button>
      <input [class.hidden]="!needsReset" type="password" class="form-control" [(ngModel)]="password">
      <button (click)="CancelReset()" [class.hidden]="!needsReset" type="button" class="btn btn-primary btn-md">Cancel
        Reset</button>
    </div>
  </div>
  <div class="form-group inline-key-val">
    <label class="form-label">Created</label>
    <label [innerHTML]="created"></label>
  </div>
  <div class="form-group inline-key-val">
    <label class="form-label">Last Login</label>
    <label [innerHTML]="created"></label>
  </div>
</div>
